// extracted by mini-css-extract-plugin
module.exports = {"mainDesc":"Services_mainDesc__16iSJ","keyBenefitLine":"Services_keyBenefitLine__2Hzdg","videoWrapper":"Services_videoWrapper__3FWLy","video":"Services_video__2VDao"};